export const formatPhoneNumber = (phone: string, withCountryCode = false): string => {
  if (!phone) {
    return '';
  }

  const src = phone.replace('+1', '');
  const cityCode = src.slice(0, 3);
  const part1 = src.slice(3, 6);
  const part2 = src.slice(6);
  const leftBracket = src.length > 0 ? '(' : '';
  const rightBracket = src.length > 3 ? ')' : '';
  const space = src.length > 3 ? ' ' : '';
  const hyphen = src.length > 6 ? '-' : '';
  const country = withCountryCode ? '+1 ' : '';
  const city = `${leftBracket}${cityCode}${rightBracket}${space}`;
  const phoneNumber = `${part1}${hyphen}${part2}`;

  return `${country}${city}${phoneNumber}`;
};

export const parsePhoneNumber = (phone: string, withCountryCode = true): string => {
  if (!phone) {
    return '';
  }

  const phoneNumber = phone.replace(/\D/g, '');
  const prefix = withCountryCode ? '+1' : '';

  return `${prefix}${phoneNumber}`;
};

export const hidePhoneNumbers = (phone: string): string => {
  if (!phone) {
    return '';
  }

  return `(${phone.slice(2, 4)}*) *** **${phone.slice(-2)}`;
};
